function footerSelector() {
  const dropdownToggles = document.querySelectorAll(
    '.footer-dropdown .dropdown-toggle'
  )

  dropdownToggles.forEach((toggle) => {
    toggle.addEventListener('click', function (e) {
      e.preventDefault()
      const dropdown = this.closest('.footer-dropdown')

      // Close all other dropdowns
      document
        .querySelectorAll('.footer-dropdown.active')
        .forEach((activeDropdown) => {
          if (activeDropdown !== dropdown) {
            activeDropdown.classList.remove('active')
          }
        })

      // Toggle current dropdown
      dropdown.classList.toggle('active')
    })
  })

  // Close dropdown when clicking outside
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.footer-dropdown')) {
      document
        .querySelectorAll('.footer-dropdown.active')
        .forEach((dropdown) => {
          dropdown.classList.remove('active')
        })
    }
  })
}

export default footerSelector
